export default __webpack_public_path__ + "static/media/ZEC.ca62fb0e.png";